<header class="header-desktop">
  <div class="logo-container">
    <div class="logo"><img src="./assets/temporals/Logo_Akana_Azul.png" (click)="goToHome()" alt=""></div>
  </div>
  <div class="menu-container">
    <ul class="list-menu">
      <li class="{{ (!isCurrent('summary')) ? 'not-active' : '' }}" [ngClass]="{'active': isCurrent('summary') }"
        (click)="goToURL('')" id="summaryId">Resumen
        <hr *ngIf="isCurrent('summary')">
      </li>
      <li class="{{ (!isCurrent('stats')) ? 'not-active' : '' }}" [ngClass]="{'active': isCurrent('stats') }"
        (click)="goToURL('stats')" id="statsId">Estadísticas
        <hr *ngIf="isCurrent('stats')">
      </li>
      <li class="{{ (!isCurrent('report')) ? 'not-active' : '' }}" [ngClass]="{'active': isCurrent('report') }"
        (click)="goToURL('report')" id="reportId">Informe
        <hr *ngIf="isCurrent('report')">
      </li>
      <li class="{{ (!isCurrent('tips')) ? 'not-active' : '' }}" [ngClass]="{'active': isCurrent('tips') }"
        (click)="goToURL('tips')" id="tipsId">Consejos
        <hr *ngIf="isCurrent('tips')">
      </li>
      <li class="{{ (!isCurrent('faqs-client') ? 'not-active' : '')}}" [ngClass]="{'active': isCurrent('faqs-client') }"
        (click)="goToURL('faqs-client')" id="faqId">Preguntas Frecuentes
        <hr *ngIf="isCurrent('faqs-client')">
      </li>
      <li class="{{ (!isCurrent('settings')) ? 'not-active' : '' }}" [ngClass]="{'active': isCurrent('settings') }"
        *ngIf="showProfile" (click)="goToURL('settings')" id="profileId">Mi perfil
        <hr *ngIf="isCurrent('settings')">
      </li>
      <li (click)="goToURL('home', true)"> <img class="logout" id="logoutId"
          src="./assets/global-position/header/logout.svg" alt="Desconectar" title="Desconectar"></li>
    </ul>
  </div>
  <img *ngIf="showProfile" (click)="goToURL('settings')" id="settingsId" title="Ajustes de perfil de usuario"
    class="profile"
    src="./assets/global-position/header/profile.svg" alt="">
</header>
